var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-banner',{staticClass:"my-2",attrs:{"two-line":"","outlined":""}},[_c('v-avatar',{attrs:{"slot":"icon","color":"error","size":"40"},slot:"icon"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-close ")])],1),_vm._v(" "+_vm._s(_vm.warningText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }